<template>
  <div class="study-card-response">
    <div class="card-container">
      <div class="card-front">
        <div class="card-content">
          <span v-html="studyCardContent.FrontCard[0]"></span>
        </div>
        <div class="card-footer">
          <button @click="flip()" rounded>Flip Card</button>
        </div>
      </div>

      <div class="card-back remove">
        <div class="card-content">
          <span v-html="studyCardContent.BackCard[0]"></span>
        </div>
        <div class="card-footer">
          <button @click="flip()" rounded>Back to front</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="js">
export default {
  name: 'FlipCard',
  props: ['studyCardContent', 'bookTitle', 'chapter', 'section'],
  methods: {
    flip: function () {
      setTimeout(function () {
        const currentCard = document.querySelector('.owl-item.active')
        const cardContainer = currentCard.querySelector('.card-container')
        const cardFront = cardContainer.querySelector('.card-front')
        const cardBack = cardContainer.querySelector('.card-back')
        if (cardContainer.classList.contains('flipped')) {
          cardContainer.classList.remove('flipped')
          if (cardFront.classList.contains('remove')) {
            cardFront.classList.remove('remove')
          }
          cardBack.classList.add('remove')
        } else {
          cardContainer.classList.add('flipped')
          if (cardBack.classList.contains('remove')) {
            cardBack.classList.remove('remove')
          }
          cardFront.classList.add('remove')
        }
      }, 100)

      this.$gtm.trackEvent({
        event: 'user_flipped_study_card',
        category: 'Study Cards',
        action: 'click',
        label: 'User flipped study card',
        value: 'flip',
        productName: this.bookTitle,
        chapterName: this.chapter,
        sectionTitle: this.section,
        isCardFlipped: 'true'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables.scss";

.study-card-response {
  width: 100%;
  height: 100%;
  perspective: 1000px;
  .card-container {
    position: relative;
    width: 100%;
    height: 100%;
    transition: transform 0.5s;
    transform-style: preserve-3d;
    .card-front,
    .card-back {
      width: 100%;
      height: 100%;
      -webkit-backface-visibility: hidden; /* Safari */
      backface-visibility: hidden;
    }
    .card-front {
      height: 100%;
      background-color: #fff;
      border-style: solid;
      border-width: 1px;
      border-color: $outline-border-gray;
      display: flex;
      flex-direction: column;
      .card-header {
        font-size: $PageTitle;
        padding: 15px;
        background-color: $card-header-color;
        font-weight: bold;
      }
      .card-content {
        padding: 15px;
        height: 100%;
        overflow-y: auto;
      }
      .card-footer {
        padding: 15px;
        text-align: center;
        button {
          background-color: #fff;
          padding: 4px 20px;
          color: $primary;
          border-radius: 100px;
          border-style: solid;
          border-color: $primary;
          outline: none;
          &:active {
            background-color: $primary;
            color: #fff;
          }
        }
      }
    }
    .card-back {
      top: 0;
      transform: rotateY(180deg);
      height: 100%;
      background-color: #fff;
      border-style: solid;
      border-width: 1px;
      border-color: $outline-border-gray;
      display: flex;
      flex-direction: column;
      .card-header {
        font-size: $PageTitle;
        padding: 15px;
        background-color: $card-header-color;
        font-weight: bold;
      }
      .card-content {
        padding: 15px;
        height: 100%;
        overflow-y: auto;
      }
      .card-footer {
        padding: 15px;
        text-align: center;
        button {
          background-color: #fff;
          padding: 4px 20px;
          color: $primary;
          border-radius: 100px;
          border-style: solid;
          border-color: $primary;
          outline: none;
          &:active {
            background-color: $primary;
            color: #fff;
          }
        }
      }
    }
    .remove {
      display: none;
    }
  }
  .flipped {
    transform: rotateY(180deg);
  }
}

@media (max-width: 1023px) and (orientation: landscape) {
  .study-card-response {
    .card-container {
      .card-front,
      .card-back {
        .card-content {
          padding: 10px;
        }
        .card-footer {
          padding: 8px;
          .button {
            padding: 4px 10px;
          }
        }
      }
    }
  }
}
</style>
